import React from 'react';
import { motion } from 'framer-motion';
import type { StylistCardProps } from './types';

const StylistCard: React.FC<StylistCardProps> = ({ stylist, onSelect, buttonText = 'Book Now' }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      onClick={() => onSelect(stylist)}
      className="rounded-lg overflow-hidden hover:shadow-md transition-shadow border border-gray-200 dark:border-gray-600 hover:border-primary relative h-96 cursor-pointer"
    >
      {/* Full card background image */}
      <img 
        src={stylist.image} 
        alt={stylist.name}
        className="absolute inset-0 w-full h-full object-cover"
      />
      
      {/* Gradient overlay only at bottom for content */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent"></div>
      
      {/* Content overlay */}
      <div className="relative h-full flex flex-col">
        {/* Content area with light black background */}
        <div className="flex-1 flex flex-col justify-end">
          <div className="bg-black/30 p-3 pb-14">
            <h3 className="text-base font-bold text-white mb-1 line-clamp-1">
              {stylist.name}
            </h3>
            <p className="text-white text-xs font-semibold mb-1">
              {stylist.role}
            </p>
          </div>
        </div>
        
        {/* Button fixed at bottom */}
        <div className="absolute bottom-0 left-0 right-0">
          <button
            onClick={() => onSelect(stylist)}
            className="w-full py-3 text-sm bg-primary text-white hover:bg-primary/90 transition-colors font-semibold"
          >
            {buttonText}
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default StylistCard;
